/* eslint-disable react/prop-types */ // TODO: add props
import { Link } from 'react-router-dom';
import { AnnotatedProgressBar } from 'edrolo-style-guide';
import { StudentResponse } from './StudentResponse';
import { useClassActivityResponses } from '../../hooks';
import NotAnsweredStudentNames from './NotAnsweredStudentNames';
import { STUDENT_RESPONSES_REFRESH_INTERVAL } from 'core/constants';
import { ErrorAlert } from 'core/components';
import PT from 'prop-types';
import cx from 'classnames';
import style from './styles.scss';

export const StudentResponses = ({
  activity,
  classId,
  lessonId,
  collabModalOptions = [],
  students = [],
  analyticsPayload = {},
}) => {
  const { data, loading, error, updateCollaborators } =
    useClassActivityResponses(
      activity.id,
      classId,
      STUDENT_RESPONSES_REFRESH_INTERVAL
    );

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!data && error) {
    return <ErrorAlert statusCode={error.status} />;
  }

  const {
    activity_responses,
    responded_profile_ids,
    not_responded_profile_ids,
  } = data;

  const total = responded_profile_ids.length + not_responded_profile_ids.length;
  const notAnsweredStudentNames = not_responded_profile_ids.map((profileId) => {
    const targetStudents = students.filter((s) => s.profile_id === profileId);
    return targetStudents.length ? targetStudents[0].display_name : '';
  });

  return (
    <section
      className={cx(style.studentResponses, {
        [style.hasResponses]: !!activity_responses.length,
      })}
    >
      <header>
        {error && (
          <p>
            <ErrorAlert statusCode={error.status} />
          </p>
        )}

        <div className={style.sectionLabel}>How students responded</div>

        <section className={style.answeredSection}>
          <p>Answered:</p>
          <AnnotatedProgressBar
            value={responded_profile_ids.length}
            total={total}
          >
            <div className={style.progress}>
              <strong>
                {responded_profile_ids.length} / {total}
              </strong>
              <span> students</span>
            </div>
          </AnnotatedProgressBar>
        </section>

        <section className={style.notAnsweredSection}>
          <p>Not Answered:</p>
          <NotAnsweredStudentNames studentNames={notAnsweredStudentNames} />
        </section>

        <Link
          className={style.link}
          to={`/class/${classId}/progress/lesson/${lessonId}/`}
          target="_blank"
        >
          View class progress
        </Link>
      </header>

      <div className={style.groupResponsesText}>
        {!activity_responses.length
          ? 'No Student Responses Submitted'
          : 'Student Responses'}
      </div>

      {activity_responses.map((activityResponse) => {
        const primaryStudents = students.filter(
          (s) => s.profile_id === activityResponse.profile
        );
        return (
          <StudentResponse
            key={activityResponse.id}
            activity={activity}
            activityResponse={activityResponse}
            student={primaryStudents.length ? primaryStudents[0] : null}
            students={students}
            classId={classId}
            updateCollaborators={updateCollaborators}
            collabModalOptions={collabModalOptions}
            analyticsPayload={analyticsPayload}
          />
        );
      })}
    </section>
  );
};

StudentResponses.propTypes = {
  activity: PT.object.isRequired,
  classId: PT.string.isRequired,
  lessonId: PT.number.isRequired,
  collabModalOptions: PT.array,
  students: PT.array,
};
